import type { BottomSideNavBarItem } from "@octopusdeploy/design-system-components";
import { CogIcon, PlatformHubIcon } from "@octopusdeploy/design-system-icons";
import type { UserResource } from "@octopusdeploy/octopus-server-client";
import { Permission } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import { repository, session } from "~/clientInstance";
import { isAllowed } from "~/components/PermissionCheck/PermissionCheck";
import type { SpaceContext } from "~/components/SpaceLoader/SpaceLoader";
import { isSpaceNotFound } from "~/components/SpaceLoader/SpaceLoader";
import { usePageArea } from "~/routing/PageAreaContext";
import { UserAccountMenu } from "../Navbar/UserAccountMenu";
export function useBottomSideNavBarItems(currentUser: UserResource, spaceContext: SpaceContext): BottomSideNavBarItem[] {
    const pageArea = usePageArea();
    const userAccountNavBarItem: BottomSideNavBarItem = {
        type: "custom",
        key: "user-menu",
        content: <UserAccountMenu currentUser={currentUser}/>,
    };
    if (!pageArea) {
        return [userAccountNavBarItem];
    }
    return [
        {
            type: "link",
            accessibleName: "Platform Hub",
            icon: <PlatformHubIcon size={24}/>,
            href: links.platformHubRootRedirect.generateUrl(),
            showLinkAsActive: "if path partially matches",
        },
        {
            type: "link",
            icon: <CogIcon size={24}/>,
            href: links.configurationRootRedirect.generateUrl(),
            accessibleName: "Configuration",
            showLinkAsActive: "if path partially matches",
            isVisible: hasConfigurationPermissions(spaceContext),
        },
        userAccountNavBarItem,
    ];
}
function hasConfigurationPermissions(spaceContext: SpaceContext) {
    if (!isSpaceNotFound(spaceContext) || spaceContext.isAlsoInSystemContext) {
        return (session.currentPermissions?.scopeToSpace(repository.spaceId).hasAnyPermissions() ||
            isAllowed({
                permission: [Permission.AdministerSystem, Permission.EventView, Permission.TeamView, Permission.UserView, Permission.UserRoleView, Permission.SpaceView, Permission.SpaceEdit, Permission.SpaceCreate, Permission.SpaceDelete],
                wildcard: true,
            }));
    }
    return false;
}
